import CheckoutNewSchool from './CheckoutNewSchool.page';

export default CheckoutNewSchool;
